import React from 'react';
import PropTypes from 'prop-types';

import { CDN_URL } from '../../constants';

const ScholarCard = ({ image, first_name: firstName, last_name: lastName, link, roles }) => {
  const fullName = [firstName, lastName].filter((e) => !!e).join(' ');
  const hasRoles = !!roles.length;

  return (
    <div className='scholar-card'>
      <a className='scholar-card__link' href={link} rel='noreferrer' target='_blank'>
        {image && (
          <div className='scholar-card__media'>
            <img
              src={`${CDN_URL}${image}`}
              alt={fullName}
              className='scholar-card__img'
              loading='lazy'
            />
          </div>
        )}
        {(firstName || lastName) && (
          <div className='scholar-card__name'>
            {firstName && <span className='scholar-card__first-name'>{firstName}</span>}
            {firstName && lastName && ' '}
            {lastName && <span className='scholar-card__last-name'>{lastName}</span>}
          </div>
        )}
        {hasRoles && (
          <div className='scholar-card__roles'>
            <ul className='scholar-card__roles-list'>
              {roles.map((item, index) => {
                return (
                  <li
                    className='scholar-card__roles-list-item'
                    key={`scholar-card__roles-list-item-${index}`}
                    dangerouslySetInnerHTML={{ __html: item?.title }}
                  />
                );
              })}
            </ul>
          </div>
        )}
      </a>
    </div>
  );
};

ScholarCard.propTypes = {
  image: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  link: PropTypes.string,
  roles: PropTypes.array,
};

export default ScholarCard;
